import React, { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import styles from './style.module.scss';
import { Button } from 'components/buttons';
import { SIZE_MEDIUM } from 'constants/sizes';
import { THEME_DARK } from 'constants/color-theme';

export const SpecToolbar = ({
  handleClearCode,
  handleCopyToClipboard,
  codeComplete,
  loadingAssets,
  loadingDatasheet,
  handleAssetPack,
  handleDatasheetDownload,
  handleViewDatasheetDownload,
}) => {
  const prodName = useSelector((state) => state.product.data.productName);
  const referenceBox = useRef(null);

  function returnButton(button) {
    // If code is complete
    if (button === 'asset') {
      return (
        <Button
          icon="add"
          size={SIZE_MEDIUM}
          theme={THEME_DARK}
          label="create assets pack"
          loading={loadingAssets}
          greyed={!codeComplete}
          handleClick={handleAssetPack}
        />
      );
    }
    if (button === 'datasheet') {
      // If currently loading
      return (
        <div className={styles['datasheet-button-holder']}>
          <div className={styles['button-holder']}>
            <Button
              size={SIZE_MEDIUM}
              theme={THEME_DARK}
              label="view datasheet"
              loading={loadingDatasheet}
              greyed={!codeComplete}
              handleClick={() =>
                handleViewDatasheetDownload(
                  referenceBox.current?.value?.trim() || ''
                )
              }
              stylesClass={'first-half'}
            />
            <Button
              size={SIZE_MEDIUM}
              theme={THEME_DARK}
              label=""
              icon="download"
              loading={loadingDatasheet}
              greyed={!codeComplete}
              handleClick={() =>
                handleDatasheetDownload(
                  referenceBox.current?.value?.trim() || ''
                )
              }
              stylesClass={'on-end'}
              referenceRef={referenceBox}
            />
          </div>
          <div className={styles['ref-holder']}>
            <input
              placeholder="add reference?"
              type="text"
              ref={referenceBox}
              maxLength="15"
            />
          </div>
        </div>
      );
    }
  }

  const pdfDownload = useSelector((state) => state.pdfDownloads.pdfDownloads);
  const assetBtn = returnButton('asset');
  const datasheetBtn = returnButton('datasheet');

  useEffect(() => {
    async function downloadPDF(url) {
      /*
      if (!bloob.ok) {
        throw new Error('Failed to fetch file');
      }
*/
      //const blob = await bloob.blob();
      //const url = URL.createObjectURL(bloob);

      //window.open(url, '_blank');

      const a = document.createElement('a');
      a.href = url;

      a.download =
        'orluna-datasheet-' + localStorage.getItem('currentProdCode'); // Optional override of filename
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);

      URL.revokeObjectURL(url); // Clean up
    }

    if (pdfDownload) {
      downloadPDF(pdfDownload.pdfDownloads);
      console.log(pdfDownload.pdfDownloads);

      //window.URL.revokeObjectURL(pdfDownload);
    }
  }, [pdfDownload]);

  /*
  useEffect(() => {
    async function downloadPDF() {
      const response = await fetch('/wp-json/myplugin/v1/download', {
        method: 'GET',
      });

      if (!response.ok) {
        throw new Error('Failed to fetch file');
      }

      const blob = await response.blob();
      const url = URL.createObjectURL(blob);

      const a = document.createElement('a');
      a.href = url;
      a.download = 'download.pdf'; // Optional override of filename
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);

      URL.revokeObjectURL(url); // Clean up
    }

    async function forceDownloadPDF(url) {
      const response = await fetch(url);
      const blob = await response.blob();
      const blobUrl = URL.createObjectURL(blob);

      const a = document.createElement('a');
      a.href = blobUrl;
      //a.download = filename || 'file.pdf';
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(blobUrl);
    }


    if(pdfDownload){
      forceDownloadPDF(pdfDownload);
      window.URL.revokeObjectURL(pdfDownload);
    }
  }, [pdfDownload]);
*/
  return (
    <>
      <div className={styles['spec-toolbar']}>
        <h3>{prodName}</h3>
        <nav className={styles['toolbar-details']}>
          <span onClick={() => handleClearCode()}>clear code</span> |{' '}
          <span onClick={() => handleCopyToClipboard()}>copy to clipboard</span>{' '}
          | <span className={styles['button-holder']}>{assetBtn}</span>{' '}
          <span className={styles['button-holder']}>{datasheetBtn}</span>
        </nav>
      </div>
    </>
  );
};
